<template>
  <div>
    <footer class="mt-5">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center py-3">
            <router-link to="/" class="blanco terminos">Volver al Inicio</router-link>
          </div>
        </div>
      </div>
    </footer>

    <span class="loading" v-bind:class="{active: this.$store.state.loading}">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
